<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="107"
    height="107"
    viewBox="0 0 107 107"
  >
    <g transform="translate(-1015.263 -276.263)">
      <g transform="translate(1037.904 296.569)">
        <line class="a" y2="61.077" transform="translate(30.86 3.299)" />
        <path
          class="a"
          d="M1158.529,369.575s.266-.261.964.321c1.929,1.608,4.179,15.43,15.752,10.287"
          transform="translate(-1120.276 -349.882)"
        />
        <path
          class="a"
          d="M1102.383,379.8s-.109-.356-1-.178c-2.462.491-11.043,11.559-18.752,1.512"
          transform="translate(-1076.175 -355.724)"
        />
        <path
          class="a"
          d="M1111.292,405.411c-3.215-2.25-5.786-5.786-2.991-14.605"
          transform="translate(-1090.397 -362.252)"
        />
        <path
          class="a"
          d="M1170.806,351.159s1.607-8.358,7.715-8.358c9.965,0,8.036,16.073,8.036,16.073s7.393,10.287-3.536,17.68c-6.871,4.648-10.929-3.858-10.929-3.858"
          transform="translate(-1127.409 -334.359)"
        />
        <path
          class="a"
          d="M1085.418,351.283s-1.48-7.715-7.588-7.715c-9.965,0-8.164,15.43-8.164,15.43s-7.393,10.287,3.536,17.68c6.871,4.648,10.93-3.857,10.93-3.857"
          transform="translate(-1067.222 -334.805)"
        />
        <path
          class="a"
          d="M1094.077,331.093s2.25-7.072,7.072-4.5c0,0,4.822-7.393,12.537-1.929"
          transform="translate(-1082.826 -322.651)"
        />
        <path
          class="a"
          d="M1161.258,331.093s-2.25-7.072-7.072-4.5c0,0-4.822-7.393-12.537-1.929"
          transform="translate(-1110.468 -322.651)"
        />
        <path
          class="a"
          d="M1155.46,429.5s5.144,4.179,3.536,10.287"
          transform="translate(-1118.492 -384.737)"
        />
        <path
          class="a"
          d="M1116.339,441.013s-5.143,4.179-3.536,10.287"
          transform="translate(-1093.526 -391.425)"
        />
        <path
          class="a"
          d="M1166.277,424.133c1.929,8.358-6.108,12.216-6.108,12.216,2.25,8.036-4.179,7.715-4.179,7.715s-8.679,13.18-15.108,1.286"
          transform="translate(-1110.022 -381.616)"
        />
        <path
          class="a"
          d="M1080.565,424.133c-1.929,8.358,6.108,12.216,6.108,12.216-2.25,8.036,4.179,7.715,4.179,7.715s8.059,12.216,14.81,1.286"
          transform="translate(-1074.802 -381.616)"
        />
      </g>
      <g transform="translate(1016.763 277.763)">
        <line
          class="b"
          x2="7.394"
          y2="7.394"
          transform="translate(15.354 15.354)"
        />
        <line
          class="b"
          x2="7.394"
          y2="7.394"
          transform="translate(81.092 81.092)"
        />
        <line
          class="b"
          x1="7.394"
          y2="7.394"
          transform="translate(81.092 15.354)"
        />
        <line
          class="b"
          x1="7.394"
          y2="7.394"
          transform="translate(15.354 81.092)"
        />
        <line class="b" x1="10.456" transform="translate(93.544 52)" />
        <line class="b" x1="10.456" transform="translate(0 52)" />
        <line class="b" y1="10.456" transform="translate(52 93.544)" />
        <line class="b" y1="10.456" transform="translate(52)" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
.a,
.b {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 3px;
}
.a {
  stroke: #fff;
  transition: stroke 0.2s linear;
}
.b {
  stroke: #ffdf22;
}
</style>
